import { BottomSheet, Drop } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

import InviteToVideoCall from 'src/components/ResumeCard/Actions/Additional/Menu/InviteToVideoCall';
import { AdditionalMenuProps } from 'src/components/ResumeCard/Actions/Additional/Menu/types';

import styles from './styles.less';

const AdditionalMenu: TranslatedComponent<AdditionalMenuProps> = ({ isMenuVisible, closeMenu, menuDropProps }) => {
    const content = <InviteToVideoCall closeMenu={closeMenu} />;

    return (
        <>
            <Drop visible={isMenuVisible} onClose={closeMenu} {...menuDropProps}>
                <div className={styles.drop}>{content}</div>
            </Drop>
            <BottomSheet visible={isMenuVisible} onClose={closeMenu}>
                {content}
            </BottomSheet>
        </>
    );
};

export default translation(AdditionalMenu);
